import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import Paper from "@material-ui/core/Paper";
import SaveIcon from "@material-ui/icons/Save";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  attributeContainer: {
    display: "flex",
    flexDirection: "row",
  },
  attributeText: {
    width: "100%",
  },
  attributeEditButton: {
    width: "1fr",
  },
  attributeCancelButton: {
    width: "1fr",
  },
});

class AttributeEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      contentBuffer: props.value,
    };
    this.textInput = React.createRef();
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.attributeContainer}>
        <TextField
          multiline={this.props.altType === "TEXTAREA"}
          rows={this.props.altType === "TEXTAREA" ? 2 : 1}
          component={Paper}
          elevation={1}
          className={`textfield ${classes.attributeText}`}
          value={
            this.state.editing ? this.state.contentBuffer : this.props.value
          }
          label={this.props.label}
          type={this.props.type}
          variant="outlined"
          InputProps={{
            readOnly: !this.state.editing,
          }}
          inputRef={this.textInput}
          onChange={this.handleTextEdit}
          onKeyDown={this.handleTextEditKeyPresses}
        />

        <Button
          className={classes.attributeEditButton}
          variant="contained"
          color="primary"
          onClick={this.handleEditButtonClick}
          disabled={!this.props.editable}
        >
          {this.state.editing ? <SaveIcon /> : <EditIcon />}
        </Button>

        <Button
          className={classes.attributeCancelButton}
          variant="contained"
          color="secondary"
          onClick={this.handleCancelButtonClick}
          disabled={!this.state.editing}
        >
          <CloseIcon />
        </Button>
      </div>
    );
  }

  handleTextEdit = (event) => {
    this.setState({ contentBuffer: event.target.value });
  };

  handleTextEditKeyPresses = (event) => {
    if (this.state.editing) {
      if (event.key === "Enter") this.handleEditButtonClick();
      if (event.key === "Escape") this.handleCancelButtonClick();
    }
  };

  handleCancelButtonClick = () => {
    this.setState({
      editing: false,
      contentBuffer: this.props.value,
    });
  };

  handleEditButtonClick = () => {
    const newEditingState = !this.state.editing;

    if (newEditingState) {
      setTimeout(() => this.textInput.current.focus(), 120);
    } else {
      if (this.props.value !== this.state.contentBuffer) {
        this.props.onEdit(
          this.props.url,
          this.props.attributeId,
          this.state.contentBuffer
        );
      }
    }

    this.setState({
      editing: newEditingState,
    });
  };
}

export default withStyles(styles)(AttributeEditor);
